export const DEV_CLIENT_URL = '';
export const STAGING_CLIENT_URL = '';
export const PROD_CLIENT_URL = '';



// WEBPACK FOOTER //
// ./src/constants/sso.js